import { useCallback, useEffect } from 'react';
import { useSnackbar } from 'notistack';

export function useApiErrorSnackbar(err, defaultMessage) {
  const { enqueueSnackbar } = useSnackbar();
  const showError = useCallback(
    (error) => enqueueSnackbar(error, { variant: 'error' }),
    [enqueueSnackbar],
  );
  useEffect(() => {
    if (err) {
      const error = err.data && err.data.error;

      if (Array.isArray(error)) {
        error.forEach((err) => {
          showError(err);
        });
      }

      if (typeof error === 'string') {
        showError(error);
      }
      if (err.data?.message) {
        showError(err.data.message || defaultMessage);
      }
    }
  }, [err, defaultMessage, showError]);
}
